<template>
  <div>
    <div class="line__vertical-mains"></div>
    <sub-header :micrositeUrl="micrositeUrl" />
    <div v-if="locations.length > 0" class="map_filter">
      <div class="maphighlight__box">
          <h1 class="caption__select">
                  <span>Seleccione una privada, clic para ver detalles</span>
                </h1>
        <map-highlight class="canadas-map" v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img"  :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel" :indicators="indicators" :type="type" :locationsDisabled="disabledLocations"/>
        <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img"/>
        <div class="line_horizontal"></div>
        <Availables
            class="availables-mobile"
            :amountAvailables="amountAvailables"
            :nivel="nivel"
            :url="url"

        />
      </div>
      <div class="select__box" :class="selectHide">
        <Select
            v-if="locations.length > 0 && rangeFilter.length > 0"
            :locations="locations"
            @change="changeRange"
            :rangeFilter="rangeFilter"
        />
        <Availables
            class="availables-desk"
            :amountAvailables="amountAvailables"
            :nivel="nivel"
            :url="url"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { locationsData } from "../../../../utils/canadas/data_disabled_canadas_terrenos.js"
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../../core/SubHeader.vue";
import MapHighlight from "../../../core/MapHighlight";
import Select from "../../../core/Select.vue";
import Availables from "../../../core/rediseno/Availables.vue";
import Button from "../../../core/Button.vue";
export default {
  name: "Main",
  components: {
    SubHeader,
    MapHighlight,
    Select,
    Availables,
    Button,
  },
  data() {
    return {
      id: 51,
      nivel: "towerStageLevel",
      levelId: 0,
      type: "casas",
      desarrollo: "canadas_casas",
      arrFilteredLocations: [],
      url: "canads_casas",
      micrositeUrl: "https://www.tresmarias.com.mx/canadas/casas",
      imgSet: [
        {
          name: 'canadas_casas',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/casas/MainCasasCanadasNva.png',
          width: '3372',
          height: '5505',
          id: 51,
          levelId: 0,
          route: 'canads_casas',
          nivel: 'towerStageLevel',
          transform: '',
          viewBox: '0 0 3372 5505'
        }
      ],
      indicators: [ 
        {text: 'PRIVADA 0'},
        {text: 'PRIVADA 1'},
        {text: 'PRIVADA 2'},
        {text: 'PRIVADA 3'},
        {text: 'PRIVADA 4'},
        {text: 'PRIVADA 5'},
        {text: 'PRIVADA 6'},
        {text: 'PRIVADA 7'},
        {text: 'PRIVADA 8'},
        {text: 'PRIVADA 9'},
        {text: 'PRIVADA 10'},
        {text: 'PRIVADA 18'},
        {text: 'PRIVADA 19'},
        {id: 233, text: 'PRIVADA 16', transform: 'matrix(1 0 0 1 860.1255 3645.479)',cxB: 1160, cyB: 3630, rB: 35, cxW: 1160, cyW: 3630, rW: 16, x1: 1686, y1: 3629.03, x2: 1191.68, y2: 3630.19,  status: true },
        {id: 178, text: 'PRIVADA 20'},
        {id: 233, text: 'PRIVADA 17', transform: 'matrix(1 0 0 1 670.1255 4135.479)',cxB: 960, cyB: 4120, rB:35, cxW: 960, cyW: 4120, rW: 16, x1: 1484.04, y1: 4120.55, x2: 989.72, y2: 4121.71, status: true },
        {id: 233, text: 'PRIVADA 21', transform: 'matrix(1 0 0 1 0 2825.479)', cxB: 285, cyB: 2807, rB: 35, cxW: 285, cyW: 2807, rW: 16, x1: 560.39, y1: 2807.87, x2: 301.16, y2: 2808.48, status: true },
      ],
      // si no hay filtro volver rangeFilter a false
      rangeFilter: false,
      disabledLocations:locationsData,
    };
  },

  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
    development() {
      return { id: this.id, level: 0 };
    },
    existFilter() {
      let arrExistFilter;
      if (this.rangeFilter) {
        arrExistFilter = this.arrFilteredLocations;
      } else if (this.rangeFilter === false) {
        arrExistFilter = this.locations;
      }
      return arrExistFilter;
    },
    amountAvailables(){
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.available > 0
      );
      return newArrfiltered;
    },
    selectHide(){
      if(this.rangeFilter == false){
        return 'u__dipslay--none'
      }else{
        return ''
      }
    }
  },
  methods: {
    ...mapActions(["getTowerStageLevels", "clearCoords"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },
  },
  async created() {
    await this.clearCoords();
    await this.getTowerStageLevels(this.development);
  },
  async beforeDestroy(){
    await this.clearCoords()
  }
};
</script>
